import dayjs, { Dayjs } from 'dayjs';

export class FormatUtils {
  static formatAmount = (amount?: number | null, currency?: string) => {
    if (amount === null || typeof amount === 'undefined') return '-';

    const c = currency ? currency + ' ' : '';
    const absAmount = amount >= 0 ? amount : -amount;
    const d = Math.floor(absAmount);
    const n = Array.from(String(d))
      .reverse()
      .join('')
      .match(/\d{1,3}/g)!
      .join(',')
      .split('')
      .reverse()
      .join('');
    const sign = amount >= 0 ? '' : '-';
    const p = Math.round((absAmount - d) * 100);

    return `${c}${sign}${n}.${p < 10 ? '0' : ''}${p}`;
  };

  static formatCardNumber = (number?: string | number, { short }: { short?: boolean } = {}) => {
    const str = String(number);
    return (short ? '' : 'xxxx xxxx xxxx ') + str.substr(-4);
  };

  static formatValidThru = (valid?: string | null) => (valid ? dayjs(valid).format('MM/YY') : null);

  static formatDate = (date: string | Date | Dayjs) => dayjs(date).format('DD.MM.YYYY');

  static formatDateToISO = (date: string | Date | Dayjs) => dayjs(date).toISOString().substring(0, 10);

  static formatDateTimeFromToday(date: string | Date | Dayjs): string {
    const parsedDate = dayjs(date);
    if (parsedDate.isSame(new Date(), 'day')) return parsedDate.format('HH:mm');
    return parsedDate.format('DD/MM/YYYY HH:mm');
  }
}
